// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f9de85a9","453":"316a2396"}[chunkId] + ".chunk.js";
};